import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-3 mx-auto max-w-[1366px] pt-12 md:pt-[60px]',
    screen: 'relative min-h-[597px] md:h-[400px] lg:h-[570px]',
    bg: 'bg-[image:var(--bg-sm)] bg-cover bg-center md:bg-[image:var(--bg)]',
    start:
      'relative z-1 h-full px-4 pt-12 md:flex md:items-center md:px-0 md:pt-0 md:pl-[30px] lg:pl-[60px] xl:pl-[132px]',
    startContent: 'relative z-1 max-w-[350px] lg:max-w-[490px]',
    startImage:
      'absolute bottom-0 left-0 w-full object-cover object-bottom md:top-0 md:right-0 md:left-auto md:h-full md:w-auto md:object-center',
    label:
      'inline-flex h-[25px] items-center justify-center rounded-full bg-[#00BBDC] px-2 text-sm leading-none font-medium tracking-[-0.5px] text-white uppercase',
    startTitle:
      'mt-3 mb-8 text-[28px] leading-[1.3] font-medium md:text-[32px]',
    primaryBtn:
      'flex h-[50px] w-full cursor-pointer items-center justify-center border border-[#003A70] bg-[#003A70] text-base leading-[1.2] font-semibold tracking-[-1px] text-white uppercase md:max-w-[276px] lg:hover:bg-white/70 lg:hover:text-[#003A70]',
    whiteBtn:
      'border-white bg-white text-black lg:hover:border-[#003A70] lg:hover:bg-white/70 lg:hover:text-[#003A70]',
    quiz: 'h-full bg-cover bg-center px-4 py-6 md:px-0 md:py-0',
    back: 'mb-8 flex items-center gap-[7px] md:absolute md:top-5 md:left-5 md:z-2 lg:top-8 lg:left-[107px] xl:left-[161px]',
    backText:
      'pt-[2px] text-sm font-medium tracking-[1px] text-[#34363C] uppercase',
    question:
      'flex h-full flex-col items-center justify-center md:mx-auto md:max-w-[790px] md:px-0 md:pt-3',
    questionTitle:
      'mb-8 text-center text-[22px] leading-[1.3] font-medium text-black md:mb-5 md:text-[30px] lg:mb-12 lg:max-w-[800px] lg:text-[40px] lg:leading-[1.2]',
    answers:
      'flex w-full flex-col gap-3 self-stretch md:grid md:grid-cols-2 md:gap-5 [&>li]:w-full',
    answer:
      'flex min-h-[98px] w-full cursor-pointer flex-col items-center justify-center rounded-[20px] bg-white/40 px-[25px] text-center backdrop-blur-[30px] md:min-h-[124px] md:rounded-[32px] md:px-[42px] lg:min-h-[174px] lg:hover:bg-white/70',
    answerActive: 'bg-[#00BBDC] text-white lg:hover:bg-[#00BBDC]',
    answerText:
      'text-base leading-[1.5] md:text-lg lg:text-2xl lg:leading-[1.2]',
    bottom:
      'absolute inset-x-0 bottom-6 flex flex-wrap items-center justify-between px-4 md:bottom-10 md:flex-nowrap md:px-5 lg:px-10',
    note: 'w-full text-sm leading-[1.5] font-light text-[#1F1F1F] md:w-auto md:max-w-[280px] md:text-base',
    pages:
      'mt-2 flex gap-[26px] md:absolute md:top-1/2 md:left-1/2 md:mt-0 md:-translate-x-1/2 md:-translate-y-1/2',
    page: 'cursor-pointer text-lg leading-[1.3] font-light text-[#1F1F1F]',
    pageActive: 'font-medium text-[#00BBDC]',
    next: 'mt-2 inline-flex cursor-pointer items-center gap-4 rounded-full bg-white/20 py-1 pr-1 pl-6 shadow-[0_0_12px_rgba(0,0,0,0.05)] backdrop-blur-[30px] md:mt-0 lg:hover:bg-white/40',
    nextDisabled: 'pointer-events-none opacity-50',
    nextText:
      'text-lg leading-[1.3] text-[#1F1F1F] md:text-xl md:leading-[1.4]',
    nextIcon:
      'flex size-11 items-center justify-center rounded-full bg-[#003A70] text-white md:size-[60px]',
    thank:
      'h-full bg-cover bg-center px-4 py-10 text-center md:px-0 md:pt-[156px]',
    thankLogo: 'mx-auto mb-[116px] w-[241px] md:mb-10',
    thankTitle:
      'mb-10 text-[22px] leading-[1.5] font-medium md:text-[40px] md:leading-[1.2]',
    thankBtns: 'flex flex-col items-center justify-center gap-4 md:flex-row',
    results: 'mt-[51px] md:mt-[60px] md:px-10 md:pt-10',
    categories: 'flex flex-wrap justify-between',
    categoryMulti: 'w-full',
    resultsTitle:
      'mb-[35px] px-3 text-[22px] leading-[1.3] font-medium text-[#003A70] md:mb-8 md:px-0 md:text-[40px]',
    category: 'pb-12 last:pb-0 md:pb-[60px]',
    categorySingle: 'w-full lg:w-[48%]',
    categoryLabel:
      'mx-3 mb-4 flex h-9 items-center justify-center rounded-full bg-[#cde4ef] text-xl leading-[1.5] font-medium text-[#003A70] md:mx-0 md:mb-3 md:h-8',
    categoryList: 'grid gap-6 lg:grid-cols-2 lg:gap-x-[60px]',
    categorySlider:
      'relative pb-12 md:[--slide-size:50%] md:[--slide-spacing:60px]',
    mobileSlider:
      'relative pb-[52px] pl-3 [--slide-size:calc(100%/1.18)] [--slide-spacing:12px] lg:px-3',
    mobileBanner: 'relative h-full min-h-[540px] w-full',
    categoryNav:
      'absolute bottom-0 left-1/2 z-1 flex w-20 -translate-x-1/2 justify-between',
    mobileNav:
      'absolute bottom-0 left-1/2 z-1 flex w-[72px] -translate-x-1/2 justify-between',
    categoryNavBtn:
      'flex size-6 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[#003A70] disabled:cursor-not-allowed disabled:text-[#A6A6A6]',
    mobileNavBtn:
      'flex h-6 w-5 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[#003A70] disabled:cursor-not-allowed disabled:text-[#A6A6A6] [&_svg]:size-5',
    part: 'grid w-full min-w-0 items-stretch gap-3 px-3 md:grid-cols-[calc(295/613*100%)_calc(310/613*100%)] md:justify-between md:gap-0 md:px-0',
    banner: 'block h-auto w-full',
    counter:
      'absolute right-0 bottom-[21px] left-0 z-1 mx-auto flex h-11 w-[146px] items-center justify-center rounded-full bg-black/5 text-white backdrop-blur-[20px]',
    counterBtn:
      'absolute top-1/2 flex size-5 -translate-y-1/2 items-center justify-center border-0 bg-transparent p-0 text-white',
    counterCurrent: 'text-2xl leading-9',
    counterAll: 'text-base leading-6 font-light'
  }
});
